/* Quinn cart-drawer fix: widget add-to-cart + cart icon → drawer, modal close */
(function(){
  if(typeof window.routes==='undefined'||!window.routes.cart_add_url)return;
  var cartDrawer=document.querySelector('cart-drawer');
  if(!cartDrawer)return;

  function isCartAddForm(f){
    if(!f||f.tagName!=='FORM')return false;
    var a=(f.getAttribute('action')||f.action||'').toLowerCase();
    return a.indexOf('cart/add')!==-1;
  }
  function isThemeProductForm(f){return f.closest&&f.closest('product-form');}
  function openCartDrawerWithResponse(r){
    if(!r.sections||!cartDrawer.renderContents)return;
    if(cartDrawer.classList.contains('is-empty'))cartDrawer.classList.remove('is-empty');
    cartDrawer.renderContents(r);
  }

  function closeQuinnModal(){
    var b=document.querySelector('.quinn_model_backdrop.open')||document.querySelector('[class*="quinn"][class*="backdrop"].open');
    if(b){b.classList.remove('open');b.style.display='none';}
    var c=document.querySelector('.quinn_modal_close')||document.querySelector('button[class*="quinn"][class*="close"]');
    if(c)c.click();
  }

  document.addEventListener('click',function(e){
    var t=e.target;
    if(!t.closest||(!t.closest('.quinn_cart_button')&&!t.closest('[componentname="CartButton"]')&&!t.classList.contains('quinn_cart_button')))return;
    e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();
    closeQuinnModal();
    if(typeof window.handleFloCartBtn==='function')window.handleFloCartBtn();
    else if(cartDrawer&&typeof cartDrawer.open==='function')cartDrawer.open();
  },true);

  document.addEventListener('submit',function(e){
    var f=e.target;
    if(!isCartAddForm(f)||isThemeProductForm(f))return;
    e.preventDefault();e.stopPropagation();
    var btn=f.querySelector('[type="submit"]');
    if(btn){btn.setAttribute('aria-disabled','true');btn.classList.add('loading');}
    var fd=new FormData(f);
    fd.append('sections','cart-drawer,cart-icon-bubble');
    fd.append('sections_url',window.location.pathname);
    fetch(window.routes.cart_add_url,{method:'POST',headers:{'X-Requested-With':'XMLHttpRequest'},body:fd})
      .then(function(r){return r.json();})
      .then(function(d){
        if(d.status&&d.status!==200){if(typeof window.alert!=='undefined')window.alert(d.description||'Could not add item.');return;}
        openCartDrawerWithResponse(d);
      })
      .catch(function(){f.submit();})
      .finally(function(){
        if(btn){btn.removeAttribute('aria-disabled');btn.classList.remove('loading');}
      });
  },true);
})();
